import { render, staticRenderFns } from "./BidAmounts.vue?vue&type=template&id=3fe54500&scoped=true&"
import script from "./BidAmounts.vue?vue&type=script&lang=js&"
export * from "./BidAmounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe54500",
  null
  
)

export default component.exports